module.exports = __webpack_public_path__ + "img/dk.e0072fdc.jpg";